<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		fill="currentColor"
		class="ki ki-chevron-down"
		viewBox="0 0 24 24"
	>
		<path d="M4,6.6l8,8l8-8L21.4,8L12,17.4L2.6,8L4,6.6z" />
	</svg>
</template>

<script setup lang="ts">
interface Props {
	width?: number;
	height?: number;
}
withDefaults(defineProps<Props>(), {
	width: 24,
	height: 24
});
</script>
